import { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/**
 * 共通コンポーネント - DOM 要素 トレードバージョン
 *   以下、次の用途で使用する
 *     モーダルボディに DOM 要素を引き渡す場合
 *     子コンポーネントを内包する必要がある場合 (複雑な構造を持つなど)
 *
 *   使用箇所
 *     セミナー画面
 *       1. セミナー一覧 > 絞込み条件 (SPのみ)
 */
class RecieverDomElements extends PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

RecieverDomElements.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RecieverDomElements;



// WEBPACK FOOTER //
// ./src/components/Modal/RecieverDomElements.js